import { Amplify } from 'aws-amplify';
import { Provider } from 'react-redux';

import 'src/shared/i18n';

import { BootBoundary } from '@/console/host/boot-boundary';
import { ExperienceGate } from '@/console/host/experience-gate';
import { amplifyConfiguration } from '@/shared/aws-export';
import store from '@/shared/redux/store/store';

Amplify.configure(
  amplifyConfiguration({
    userPoolId: import.meta.env.VITE_APP_AWS_USER_POOLS_ID,
    userPoolClientId: import.meta.env.VITE_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
  }),
);

// useTranslation suspends until the detected language's chunk has loaded; only English is bundled.
export const App = () => (
  <Provider store={store}>
    <BootBoundary>
      <ExperienceGate />
    </BootBoundary>
  </Provider>
);
